import React from 'react';
import './avatar.css';

interface IAvatarProps {
  btnAction: () => void;
  content: JSX.Element | string;
  btnClass?: string;
  containerClass?: string;
}

export const Avatar = ({
  btnAction,
  content,
  btnClass = '',
  containerClass = '',
}: IAvatarProps): JSX.Element => {
  return (
    <button
      className={`avatar-button ${btnClass}`}
      onClick={btnAction}
      data-cy="AvatarButton"
    >
      <div className={`avatar-container ${containerClass}`}>{content}</div>
    </button>
  );
};
